import AlertPopup from "./ui/AlertPopup";
import BillIcon from "../icons/BillIcon";

export default function NewOrderAlerts({ alerts = [], onAlertClick }) {
	if (!Array.isArray(alerts) || alerts.length === 0) return null;

	return (
		<div className="new-order-alerts-stack">
			{alerts.map((alert, index) => (
				<div
					key={alert.alertId}
					className="new-order-alert-layer"
					style={{
						"--stack-layer": index,
						"--stack-z-index": index + 1,
					}}
				>
					<AlertPopup
						className="alert-success new-order-alert"
						onClick={() => onAlertClick && onAlertClick(alert)}
					>
						<div className="inner-content">
							<p>
								<span>
									<BillIcon className="alert-badge-icon" aria-hidden="true" />
									NUOVO ORDINE
								</span>
							</p>
							<div className="new-order-alert-details">
								<div>
									<strong>ID ordine</strong>
									<span>{alert.orderId}</span>
								</div>
								<div>
									<strong>Origine</strong>
									<span>{alert.originLabel}</span>
								</div>
							</div>
						</div>
					</AlertPopup>
				</div>
			))}
		</div>
	);
}
